// ========================================
// SERVICE - Messages
// Gestion des messages de contact
// ========================================

import { 
  collection, 
  doc, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc,
  query,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'messages';

/**
 * Récupérer tous les messages
 */
export const getMessages = async () => {
  try {
    const q = query(collection(db, COLLECTION), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    
    const messages = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    return { success: true, data: messages };
  } catch (error) {
    console.error('Erreur getMessages:', error);
    return { success: false, error: error.message, data: [] };
  }
};

/**
 * Envoyer un message (depuis le formulaire de contact)
 */
export const sendMessage = async (messageData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION), {
      ...messageData,
      isRead: false,
      createdAt: serverTimestamp()
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Erreur sendMessage:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Marquer un message comme lu
 */
export const markAsRead = async (messageId) => {
  try {
    const docRef = doc(db, COLLECTION, messageId);
    await updateDoc(docRef, {
      isRead: true,
      readAt: serverTimestamp()
    });

    return { success: true };
  } catch (error) {
    console.error('Erreur markAsRead:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Supprimer un message
 */
export const deleteMessage = async (messageId) => {
  try {
    await deleteDoc(doc(db, COLLECTION, messageId));
    return { success: true };
  } catch (error) {
    console.error('Erreur deleteMessage:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getMessages,
  sendMessage,
  markAsRead,
  deleteMessage
};